import Backbone from 'backbone';
import {
  MeterTypeEnum,
  PointScopeEnum,
  StartingTimescaleEnum,
} from 'common/proxies/enum-proxy';
import {getEnumByID, getEnumBySlug} from 'common/utils/enum-util';

export default Backbone.Model.extend({
  initialize() {
    this.decorate();
  },
  decorate(_attributes) {
    const attributes = _attributes || this.attributes;
    this.attributes.scope = getEnumBySlug(attributes.scope, PointScopeEnum);
    this.attributes.startingTimescale = getEnumBySlug(
      attributes.startingTimescale,
      StartingTimescaleEnum,
    );
    this.attributes.type = getEnumByID(attributes.type, MeterTypeEnum);
  },
  parse(response) {
    const points = response.points;
    for (let ii = 0, nn = points.length; ii < nn; ii++) {
      const point = points[ii];
      this.decorate(point);
    }
    return {points};
  },
});
